import LogoImg from "@/../../public/images/pelorus-logo.svg";
import accesssystem from "@/../../public/images/Access-control-system.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AuthFooterScreen from "../../../component/layout/authfooter";
import { FaCheck } from "react-icons/fa6";
import { LuBuilding2 } from "react-icons/lu";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { useLocation } from "react-router-dom";
import { AppRoute } from "../../../router/routerConstants";
import { useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { ValidationCons } from "../../../validation/validationConstant";
import { addCompany } from "../../../service/apis/auth.api";
import { showError, showSuccess } from "../../../utils/Common";

const VerifyYourAccountScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const empFormUrl = location.pathname.split("/")[1];
  const [loading, setLoading] = useState<boolean>(false);

  const registerStep4Formik = useFormik({
    initialValues: {
      companyName: state.companyName || "",
      companyLogo: "",
    },
    validationSchema: yup.object({
      companyName: yup
        .string()
        .trim()
        .min(
          2,
          empFormUrl === "emp"
            ? ValidationCons.COMPANY_REQUIRED
            : ValidationCons.AGENCY_REQUIRED
        )
        .required(
          empFormUrl === "emp"
            ? ValidationCons.COMPANY_REQUIRED
            : ValidationCons.AGENCY_REQUIRED
        ),
      companyLogo: yup
        .mixed()
        .required(
          empFormUrl === "emp"
            ? ValidationCons.COMPANY_LOGO
            : ValidationCons.AGENCY_LOGO
        ), // Return false if no file is provided or it's not a valid File
    }),
    onSubmit: async (values: any) => {
      setLoading(true);

      try {
        const formData = new FormData();
        formData.append("externalInfo[name]", values.companyName); // Backend expects "name"
        if (values.companyLogo) {
          formData.append("profileimageurl", values.companyLogo); // Backend expects "logo"
        }
        const response = await addCompany(formData, state?.tokenData?.access);
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            showSuccess(ValidationCons.REGISTRATION_SUCCESS);
            NavigateTo(AppRoute.LOGIN, false, state);
          }
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.message);
      }
    },
  });
  //   const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
  //     e.preventDefault();

  //     if (!tokenData) {
  //       alert("Authentication token is missing.");
  //       return;
  //     }

  //     // Prepare form data
  //     const formData = new FormData();
  //     formData.append("externalInfo[name]", companyName); // Backend expects "name"
  //     if (companyLogo) {
  //       formData.append("profileimageurl", companyLogo); // Backend expects "logo"
  //     }
  return (
    <>
      <header className="header common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo text-left">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => NavigateTo(AppRoute.SPLASH)}>
                  <img src={LogoImg} alt="logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main-authModule">
        <section className="welcomebodylogin common-padd pb-0">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 leftlargeImg">
                <img src={accesssystem} alt="logo"/>
              </div>
              <div className="col-lg-6">
                <div className="welcome-holder">
                  <h1>Create an Account</h1>
                  <p>
                    Enter your personal details to create an account and start
                    journey with us.
                  </p>
                  <div className="login-form-area verifyYouraccount-form mt-5">
                    <Form onSubmit={registerStep4Formik.handleSubmit}>
                      <div className="stepbar">
                        <ul>
                          <li className="checked">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <FaCheck />
                                </span>
                              </div>
                              <p>Step 1</p>
                              <h4>Personal Info</h4>
                            </a>
                          </li>
                          <li className="checked">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <FaCheck />
                                </span>
                              </div>
                              <p>Step 2</p>
                              <h4>Password</h4>
                            </a>
                          </li>
                          <li className="checked">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <FaCheck />
                                </span>
                              </div>
                              <p>Step 3</p>
                              <h4>Verification</h4>
                            </a>
                          </li>
                          <li className="inprogress">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <LuBuilding2 />
                                </span>
                              </div>
                              <p>Step 4</p>
                              <h4>
                                {empFormUrl === "emp"
                                  ? "Company Info"
                                  : "Agent Info"}
                              </h4>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <h3>
                        Add {empFormUrl === "emp" ? "Company" : "Agent"} Bio
                      </h3>
                      <div className="company-register mb-3">
                        <Form.Group
                          className="mb-3"
                          controlId="formBasicfirstname"
                        >
                          <Form.Label>
                            {empFormUrl === "emp" ? "Company" : "Agency"} Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter your company name"
                            name="companyName"
                            onChange={registerStep4Formik.handleChange}
                            onBlur={registerStep4Formik.handleBlur}
                            value={registerStep4Formik.values.companyName}
                            isInvalid={
                              !!registerStep4Formik.errors.companyName &&
                              Boolean(registerStep4Formik.touched.companyName)
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {typeof registerStep4Formik.errors.companyName ===
                              "string" &&
                              registerStep4Formik.errors.companyName}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group
                          className="mb-3"
                          controlId="formCompanyLogo"
                        >
                          <Form.Label>
                            Upload {empFormUrl === "emp" ? "Company" : "Agency"}{" "}
                            Logo
                          </Form.Label>
                          <Form.Control
                            type="file"
                            name="companyLogo"
                            onChange={(event: any) => {
                              const file = event.currentTarget.files
                                ? event.currentTarget.files[0]
                                : null;
                              registerStep4Formik.setFieldValue(
                                "companyLogo",
                                file
                              ); // Set file object in Formik state
                            }}
                            onBlur={registerStep4Formik.handleBlur}
                            accept="image/*"
                            isInvalid={
                              !!registerStep4Formik.errors.companyLogo &&
                              Boolean(registerStep4Formik.touched.companyLogo)
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof registerStep4Formik.errors.companyLogo ===
                              "string" &&
                              registerStep4Formik.errors.companyLogo}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>

                      <div className="btn-holder d-flex mt-5">
                        <Button
                          className="btn w-100 btn-primary"
                          variant="primary"
                          type="submit"
                        >
                          {loading ? "Saving ..." : "Next"}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default VerifyYourAccountScreen;
